import ChartDataLabels from 'chartjs-plugin-datalabels'
import HorizontalBarChart from '../../charts/horizontalBarChart'
import PieChart from '../../charts/pieChart'
import ApiService from '../../../../../../services/ApiService'
import { GChart } from 'vue-google-charts/legacy'
import TNoContent from '../../../../../../components/T/TNoContent.vue'
import { Tooltip } from 'chart.js'

export default {
  props: {
    filterProp: Object,
  },
  components: {
    HorizontalBarChart,
    PieChart,
    GChart,
    TNoContent,
  },

  data() {
    return {
      apiService: new ApiService(),
      showChart: true,
      loading: false,
      solicitedVConclued: undefined,
      page: 1,
      haveResponse: false,
      googleChartData: [],
      opt: {
        colors: ['#212950', '#C4E8F2'],
        legend: {
          position: 'top',
        },
        hAxis: {
          minValue: 0,
        },
      },
      totalPages: 1,
      pageSize: 10,
      plugins: [ChartDataLabels],
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        plugins: {
          datalabels: {
            display: true,
            color: '#fff',
            anchor: 'center',
            align: 'center',
            font: {
              weight: 'bold',
            },
            formatter: (value) => {
              return value > 0 ? value : ''
            },
          },
        },
      },
      optionsPie: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        plugins: {
          datalabels: {
            font: {
              weight: 'bold',
              size: 11,
            },
          },
        },
        hover: {
          mode: null,
        },
      },
      solicitedVConcluedChartData: {},
      requestSolicitedConclued: [],
      pieChartData: {},
      totalSolicited: [],
      totalConclued: [],
      labels: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      requestSolicitedConcluedHeader: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Tipo O.S.',
          align: 'center',
          value: 'osType',
        },
        {
          text: 'Solicitadas',
          align: 'center',
          value: 'solicited',
        },
        {
          text: 'Concluídas',
          align: 'center',
          value: 'conclued',
        },
        {
          text: 'Pendentes',
          align: 'center',
          value: 'pendents',
        },
      ],
      quantity: [],
      activityColors: {
        Calibração: '#8986ca',
        Preventiva: '#a4d233',
        Treinamento: '#3C8EA6',
        'Segurança elétrica': '#49c5b1',
        Instalação: '#414647',
        'Rotina de inspeção': '#38B890',
        Corretiva: '#3e6991',
        'Validação/Qualificação': '#CEE6D7',
        'Serviço Administrativo': '#7A8783',
      },
      backgroundColors: [],
      total: 0,
    }
  },

  async created() {
    this.listSolicitedVConclued()
  },

  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `1.7 - Serviços Solicitados x Concluídos - Período.xlsx`
      this.apiService
        .post('excel/requestedCompleted', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listSolicitedVConclued() {
      await this.apiService
        .post('reports/requestedCompletedServices', this.filterProp)
        .then((response) => {
          this.total = response.content.pager.totalItems
          this.totalPages = response.content.pager.totalPages
          this.solicitedVConclued = []
          this.labels = []
          this.quantity = []
          this.totalSolicited = []
          this.totalConclued = []
          this.googleChartData = []

          this.showChart = response.content.objects.length > 0

          response.content.objects.map((value) => {
            let changedServiceOrderType = this.switchValue(
              value.serviceOrderType
            )
            value.serviceOrderType = changedServiceOrderType
            let pendents =
              value.totalRequestedServices - value.totalCompletedServices
            this.solicitedVConclued.push({ ...value, pendents })
          })

          this.getBackgroundColors(response.content.chartsModel.length)
          response.content.chartsModel.map((obj) => {
            this.labels.push(this.$t(obj.name))
            this.quantity.push(obj.quantity)
          })

          this.getBackgroundColors(response.content.chartsModel.length)

          let totalSolicitedCounter = 0
          let totalCompletedCounter = 0

          this.haveResponse = response.content.objects

          response.content.objects.map((obj) => {
            totalSolicitedCounter += obj.totalRequestedServices
            totalCompletedCounter += obj.totalCompletedServices
          })

          this.totalSolicited.push(totalSolicitedCounter)
          this.totalConclued.push(totalCompletedCounter)

          if (this.haveResponse) {
            this.googleChartData.push([
              'QTD.',
              totalSolicitedCounter,
              totalCompletedCounter,
            ])
            this.googleChartData.unshift([
              'Números',
              this.$t('Total solicitado'),
              this.$t('Total concluído'),
            ])
          }
        })

        .catch((err) => {})

      this.fillSolicitedVConcluedChartData()
      this.fillPieChart()
    },
    fillSolicitedVConcluedChartData() {
      this.solicitedVConcluedChartData = {
        labels: [''],
        datasets: [
          {
            label: 'Tot. Solicitadas',
            data: this.totalSolicited,
            backgroundColor: '#212950',
          },
          {
            label: 'Tot. Concluídas',
            data: this.totalConclued,
            backgroundColor: '#BBCF20',
          },
        ],
      }
    },
    fillPieChart() {
      this.pieChartData = {
        labels: this.labels,
        datasets: [
          {
            backgroundColor: this.backgroundColors,
            label: '',
            data: this.quantity,
            pointRadius: 5,
            datalabels: {
              anchor: 'center',
              display: true,
              formatter: (value, ctx) => {
                let sum = 0
                let dataArr = ctx.chart.data.datasets[0].data
                dataArr.map((data) => {
                  sum += data
                })
                let percentage = ((value * 100) / sum).toFixed(0) + '%'
                return percentage
              },
              color: '#fff',
            },
          },
        ],
      }
    },
    getBackgroundColors() {
      const cleanLabels = this.labels.slice()
      this.backgroundColors = cleanLabels.map(
        (label) => this.activityColors[label] || '#7EE882'
      )
    },
    switchValue(val) {
      switch (val) {
        case 0:
          return this.$t('Treinamento')
        case 1:
          return this.$t('Segurança elétrica')
        case 2:
          return this.$t('Preventiva')
        case 3:
          return this.$t('Instalação')
        case 4:
          return this.$t('Rotina de Inspeção')
        case 5:
          return this.$t('Corretiva')
        case 6:
          return this.$t('Calibração')
        case 7:
          return this.$t('Validação/Qualificação')
        case 8:
          return this.$t('Serviços Administrativos')
      }
    },

    printUniqueResults(arrayOfObj, key) {
      // essa função remove os indices repetidos do array
      return arrayOfObj.filter((item, index, array) => {
        return array.map((mapItem) => mapItem[key]).indexOf(item[key]) === index
      })
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listSolicitedVConclued()
    },
  },
}
